import { format, fromUnixTime } from 'date-fns';

export const formatPrice = (value?: number) =>
  value !== undefined ? `${value.toFixed(2)} $` : '';

export const formatTimestamp = (timestamp?: number) =>
  timestamp ? format(fromUnixTime(timestamp), 'MMM dd, yyyy') : '';
